const dashboardEquipments = {
  aiCameras: {
    id: "",
    img: "",
    title: "",
    count: "",
    category: "",
    list: [
      {
        id: "aiCamera1",
        category: "aiCameras",
        title: "AI Camera #1",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "79%",
        incidentsObservation: "32 min ago",
        operationAlertObservation: "3 days ago",
        motionObservation: "5 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95488743558454,
          lng: -75.19127139530826,
        },
      },
      {
        id: "aiCamera2",
        category: "aiCameras",
        title: "AI Camera #2",
        area: "Construction Area, Zone 2",
        connectivityPercentage: "69%",
        incidentsObservation: "12 min ago",
        operationAlertObservation: "1 day ago",
        motionObservation: "25 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95491207509093,
          lng: -75.19192976245738,
        },
      },
      {
        id: "aiCamera3",
        category: "aiCameras",
        title: "AI Camera #3",
        area: "Construction Area, Zone 3",
        connectivityPercentage: "89%",
        incidentsObservation: "42 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "35 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.9543553048263,
          lng: -75.19161281863234,
        },
      },
      {
        id: "aiCamera4",
        category: "aiCameras",
        title: "AI Camera #4",
        area: "Construction Area, Zone 4",
        connectivityPercentage: "59%",
        incidentsObservation: "12 min ago",
        operationAlertObservation: "1 day ago",
        motionObservation: "35 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95428996454814,
          lng: -75.19129107262624,
        },
      },
      {
        id: "aiCamera5",
        category: "aiCameras",
        title: "AI Camera #5",
        area: "Construction Area, Zone 5",
        connectivityPercentage: "89%",
        incidentsObservation: "42 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "35 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954280748005736, 
          lng: -75.19046871486617,
        },
      },
      {
        id: "aiCamera6",
        category: "aiCameras",
        title: "AI Camera #6",
        area: "Construction Area, Zone 6",
        connectivityPercentage: "79%",
        incidentsObservation: "32 min ago",
        operationAlertObservation: "1 day ago",
        motionObservation: "5 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95461942616041,
          lng: -75.19013134630154,
        },
      },
    ],
  },
  envrSensors: {
    id: "",
    img: "",
    title: "",
    count: "",
    category: "",
    list: [
      {
        id: "envrSensor1",
        category: "envrSensors",
        title: "Environment Sensor#1",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "69%",
        incidentsObservation: "12 min ago",
        operationAlertObservation: "1 days ago",
        motionObservation: "25 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95477771441764,
          lng: -75.1914531461635,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "20°C",
          },
          {
            name: "Humidity",
            value: "40%",
          },
          {
            name: "Carbon Monoxide",
            value: "16Kg",
          },
          {
            name: "Battery",
            value: "75%",
          },
        ],
      },
      {
        id: "envrSensor2",
        category: "envrSensors",
        title: "Environment Sensor#2",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "74%",
        incidentsObservation: "32 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "45 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954639672355675,
          lng: -75.19164643387612,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "33°C",
          },
          {
            name: "Humidity",
            value: "65%",
          },
          {
            name: "Carbon Monoxide",
            value: "28Kg",
          },
          {
            name: "Battery",
            value: "62%",
          },
        ],
      },
      {
        id: "envrSensor3",
        category: "envrSensors",
        title: "Environment Sensor#3",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "62%",
        incidentsObservation: "22 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "45 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954847655622686,
          lng: -75.19143994017071,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "40°C",
          },
          {
            name: "Humidity",
            value: "80%",
          },
          {
            name: "Carbon Monoxide",
            value: "34Kg",
          },
          {
            name: "Battery",
            value: "74%",
          },
        ],
      },
      {
        id: "envrSensor4",
        category: "envrSensors",
        title: "Environment Sensor#4",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "58%",
        incidentsObservation: "21 min ago",
        operationAlertObservation: "1 days ago",
        motionObservation: "10 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95462126672636,
          lng: -75.19128987207084,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "50°C",
          },
          {
            name: "Humidity",
            value: "62%",
          },
          {
            name: "Carbon Monoxide",
            value: "27Kg",
          },
          {
            name: "Battery",
            value: "71%",
          },
        ],
      },
      {
        id: "envrSensor5",
        category: "envrSensors",
        title: "Environment Sensor#5",
        area: "Construction Area, Zone 4",
        connectivityPercentage: "66%",
        incidentsObservation: "38 min ago",
        operationAlertObservation: "4 days ago",
        motionObservation: "45 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95436082653723,
          lng: -75.19134869876872,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "25°C",
          },
          {
            name: "Humidity",
            value: "40%",
          },
          {
            name: "Carbon Monoxide",
            value: "36Kg",
          },
          {
            name: "Battery",
            value: "63%",
          },
        ],
      },
      {
        id: "envrSensor6",
        category: "envrSensors",
        title: "Environment Sensor#6",
        area: "Construction Area, Zone 4",
        connectivityPercentage: "67%",
        incidentsObservation: "30 min ago",
        operationAlertObservation: "3 days ago",
        motionObservation: "55 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95446113753891,
          lng: -75.19121663884086,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "48°C",
          },
          {
            name: "Humidity",
            value: "90%",
          },
          {
            name: "Carbon Monoxide",
            value: "46Kg",
          },
          {
            name: "Battery",
            value: "59%",
          },
        ],
      },
      {
        id: "envrSensor7",
        category: "envrSensors",
        title: "Environment Sensor#7",
        area: "Construction Area, Zone 4",
        connectivityPercentage: "87%",
        incidentsObservation: "37 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "23 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954474941793684,
          lng: -75.19110018599535,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "17°C",
          },
          {
            name: "Humidity",
            value: "68%",
          },
          {
            name: "Carbon Monoxide",
            value: "18Kg",
          },
          {
            name: "Battery",
            value: "88%",
          },
        ],
      },
      {
        id: "envrSensor8",
        category: "envrSensors",
        title: "Environment Sensor#8",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "74%",
        incidentsObservation: "48 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "45 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.9546330296282,
          lng: -75.19113445372379,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "60°C",
          },
          {
            name: "Humidity",
            value: "70%",
          },
          {
            name: "Carbon Monoxide",
            value: "13Kg",
          },
          {
            name: "Battery",
            value: "81%",
          },
        ],
      },
      {
        id: "envrSensor9",
        category: "envrSensors",
        title: "Environment Sensor#9",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "64%",
        incidentsObservation: "40 min ago",
        operationAlertObservation: "1 days ago",
        motionObservation: "52 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95465439685505,
          lng: -75.19089249173929,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "54°C",
          },
          {
            name: "Humidity",
            value: "80%",
          },
          {
            name: "Carbon Monoxide",
            value: "24Kg",
          },
          {
            name: "Battery",
            value: "62%",
          },
        ],
      },
      {
        id: "envrSensor10",
        category: "envrSensors",
        title: "Environment Sensor#10",
        area: "Construction Area, Zone 5",
        connectivityPercentage: "62%",
        incidentsObservation: "55 min ago",
        operationAlertObservation: "3 days ago",
        motionObservation: "42 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95437555110006,
          lng: -75.1906751931307,
        },
        infoIconList: [
          {
            name: "Temperature",
            value: "45°C",
          },
          {
            name: "Humidity",
            value: "68%",
          },
          {
            name: "Carbon Monoxide",
            value: "16Kg",
          },
          {
            name: "Battery",
            value: "63%",
          },
        ],
      },
    ],
  },
  floodSensors: {
    id: "",
    img: "",
    title: "",
    count: "",
    category: "",
    list: [
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "64°C",
          },
          {
            name: "Humidity",
            value: "60%",
          },
          {
            name: "Water Level",
            value: "0.38mm",
          },
          {
            name: "Battery",
            value: "62%",
          },
        ],
        id: "floodSensor1",
        category: "floodSensors",
        title: "Flood Sensor #1",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "79%",
        incidentsObservation: "43 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "35 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95461206390933,
          lng: -75.19155039028908,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "71°C",
          },
          {
            name: "Humidity",
            value: "69%",
          },
          {
            name: "Water Level",
            value: "0.42mm",
          },
          {
            name: "Battery",
            value: "72%",
          },
        ],
        id: "floodSensor2",
        category: "floodSensors",
        title: "Flood Sensor #2",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "87%",
        incidentsObservation: "42 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "43 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95466636050886,
          lng: -75.19159000826745,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "25°C",
          },
          {
            name: "Humidity",
            value: "40%",
          },
          {
            name: "Water Level",
            value: "0.28mm",
          },
          {
            name: "Battery",
            value: "75%",
          },
        ],
        id: "floodSensor3",
        category: "floodSensors",
        title: "Flood Sensor #3",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "89%",
        incidentsObservation: "41 min ago",
        operationAlertObservation: "3 days ago",
        motionObservation: "45 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95467648359894,
          lng: -75.19141472872683,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "35°C",
          },
          {
            name: "Humidity",
            value: "40%",
          },
          {
            name: "Water Level",
            value: "0.58mm",
          },
          {
            name: "Battery",
            value: "61%",
          },
        ],
        id: "floodSensor4",
        category: "floodSensors",
        title: "Flood Sensor #4",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "59%",
        incidentsObservation: "41 min ago",
        operationAlertObservation: "3 days ago",
        motionObservation: "35 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95467096191363,
          lng: -75.19134629767328,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "57°C",
          },
          {
            name: "Humidity",
            value: "60%",
          },
          {
            name: "Water Level",
            value: "0.30mm",
          },
          {
            name: "Battery",
            value: "72%",
          },
        ],
        id: "floodSensor5",
        category: "floodSensors",
        title: "Flood Sensor #5",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "65%",
        incidentsObservation: "20 min ago",
        operationAlertObservation: "4 days ago",
        motionObservation: "45 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954617585599394,
          lng: -75.19102935384636,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "63°C",
          },
          {
            name: "Humidity",
            value: "87%",
          },
          {
            name: "Water Level",
            value: "0.18mm",
          },
          {
            name: "Battery",
            value: "60%",
          },
        ],
        id: "floodSensor6",
        category: "floodSensors",
        title: "Flood Sensor #6",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "64%",
        incidentsObservation: "23 min ago",
        operationAlertObservation: "1 days ago",
        motionObservation: "55 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954607462500626,
          lng: -75.1908888901049,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "71°C",
          },
          {
            name: "Humidity",
            value: "70%",
          },
          {
            name: "Water Level",
            value: "0.33mm",
          },
          {
            name: "Battery",
            value: "69%",
          },
        ],
        id: "floodSensor7",
        category: "floodSensors",
        title: "Flood Sensor #7",
        area: "Construction Area, Zone 3",
        connectivityPercentage: "72%",
        incidentsObservation: "43 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "25 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95446073977229,
          lng: -75.19156782580588,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "48°C",
          },
          {
            name: "Humidity",
            value: "54%",
          },
          {
            name: "Water Level",
            value: "0.23mm",
          },
          {
            name: "Battery",
            value: "73%",
          },
        ],
        id: "floodSensor8",
        category: "floodSensors",
        title: "Flood Sensor #8",
        area: "Construction Area, Zone 4",
        connectivityPercentage: "63%",
        incidentsObservation: "54 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "35 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95441420305054,
          lng: -75.19125625681502,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "87°C",
          },
          {
            name: "Humidity",
            value: "88%",
          },
          {
            name: "Water Level",
            value: "0.42mm",
          },
          {
            name: "Battery",
            value: "87%",
          },
        ],
        id: "floodSensor9",
        category: "floodSensors",
        title: "Flood Sensor #9",
        area: "Construction Area, Zone 6",
        connectivityPercentage: "87%",
        incidentsObservation: "31 min ago",
        operationAlertObservation: "1 days ago",
        motionObservation: "45 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954591817707524,
          lng: -75.19019137355684,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "62°C",
          },
          {
            name: "Humidity",
            value: "58%",
          },
          {
            name: "Water Level",
            value: "1.0mm",
          },
          {
            name: "Battery",
            value: "84%",
          },
        ],
        id: "floodSensor10",
        category: "floodSensors",
        title: "Flood Sensor #10",
        area: "Construction Area, Zone 5",
        connectivityPercentage: "89%",
        incidentsObservation: "42 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "45 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954485064913854,
          lng: -75.19074002252994,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "69°C",
          },
          {
            name: "Humidity",
            value: "78%",
          },
          {
            name: "Water Level",
            value: "0.38mm",
          },
          {
            name: "Battery",
            value: "71%",
          },
        ],
        id: "floodSensor11",
        category: "floodSensors",
        title: "Flood Sensor #11",
        area: "Construction Area, Zone 5",
        connectivityPercentage: "64%",
        incidentsObservation: "42 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "55 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95476114938328,
          lng: -75.19096692549694,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "76°C",
          },
          {
            name: "Humidity",
            value: "75%",
          },
          {
            name: "Water Level",
            value: "0.48mm",
          },
          {
            name: "Battery",
            value: "64%",
          },
        ],
        id: "floodSensor12",
        category: "floodSensors",
        title: "Flood Sensor #12",
        area: "Construction Area, Zone 4",
        connectivityPercentage: "83%",
        incidentsObservation: "31 min ago",
        operationAlertObservation: "3 days ago",
        motionObservation: "35 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954523716806676,
          lng: -75.19124185025588,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "63°C",
          },
          {
            name: "Humidity",
            value: "60%",
          },
          {
            name: "Water Level",
            value: "0.28mm",
          },
          {
            name: "Battery",
            value: "71%",
          },
        ],
        id: "floodSensor13",
        category: "floodSensors",
        title: "Flood Sensor #13",
        area: "Construction Area, Zone 3",
        connectivityPercentage: "82%",
        incidentsObservation: "42 min ago",
        operationAlertObservation: "1 days ago",
        motionObservation: "35 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95446073977229,
          lng: -75.19156782580588,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "58°C",
          },
          {
            name: "Humidity",
            value: "60%",
          },
          {
            name: "Water Level",
            value: "0.38mm",
          },
          {
            name: "Battery",
            value: "87%",
          },
        ],
        id: "floodSensor14",
        category: "floodSensors",
        title: "Flood Sensor #14",
        area: "Construction Area, Zone 6",
        connectivityPercentage: "83%",
        incidentsObservation: "22 min ago",
        operationAlertObservation: "2 days ago",
        motionObservation: "25 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.95460930306301,
          lng: -75.19101974946808,
        },
      },
      {
        infoIconList: [
          {
            name: "Temperature",
            value: "64°C",
          },
          {
            name: "Humidity",
            value: "60%",
          },
          {
            name: "Water Level",
            value: "0.38mm",
          },
          {
            name: "Battery",
            value: "65%",
          },
        ],
        id: "floodSensor15",
        category: "floodSensors",
        title: "Flood Sensor #15",
        area: "Construction Area, Zone 1",
        connectivityPercentage: "83%",
        incidentsObservation: "12 min ago",
        operationAlertObservation: "3 days ago",
        motionObservation: "35 sec ago",
        timeStamp: "12-15-2022 | 09:00 AM",
        location: {
          lat: 39.954709613700246,
          lng: -75.19078684377709,
        },
      },
    ],
  },
};

export default dashboardEquipments;
